import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'
import {AUTH_TIPE} from "../constants/AuthConstant";

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'register',
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() => import('views/auth-views/authentication/register')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    }
]

export const protectedRoutes = [
    {
        key: 'dashboard.default',
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        component: React.lazy(() => import('views/app-views/dashboards/default')),
    },{
        key: 'master.hari_libur',
        path: `${APP_PREFIX_PATH}/master/hari_libur`,
        component: React.lazy(() => import('views/app-views/hari_libur/Index')),
    },{
        key: 'master.unit_kerja',
        path: `${APP_PREFIX_PATH}/master/unit_kerja`,
        component: React.lazy(() => import('views/app-views/unit_kerja/Index')),
    },{
        key: 'master.lokasi_kerja',
        path: `${APP_PREFIX_PATH}/master/lokasi_kerja`,
        component: React.lazy(() => import('views/app-views/lokasi_kerja/Index')),
    },{
        key: 'master.lokasi_shift',
        path: `${APP_PREFIX_PATH}/master/lokasi_shift`,
        component: React.lazy(() => import('views/app-views/lokasi_shift/Index')),
    },{
        key: 'master.dokumen',
        path: `${APP_PREFIX_PATH}/master/dokumen`,
        component: React.lazy(() => import('views/app-views/dokumen/Index')),
    },{
        key: 'master.perusahaan_subkon',
        path: `${APP_PREFIX_PATH}/master/perusahaan_subkon`,
        component: React.lazy(() => import('views/app-views/perusahaan_subkon/Index')),
    },{
        key: 'master.kelompok_tenaga',
        path: `${APP_PREFIX_PATH}/master/kelompok_tenaga`,
        component: React.lazy(() => import('views/app-views/kelompok_tenaga/Index')),
    },{
        key: 'master.kualifikasi',
        path: `${APP_PREFIX_PATH}/master/kualifikasi`,
        component: React.lazy(() => import('views/app-views/kualifikasi/Index')),
    },{
        key: 'master.tarif_upah',
        path: `${APP_PREFIX_PATH}/master/tarif_upah`,
        component: React.lazy(() => import('views/app-views/tarif_upah/Index')),
    },{
        key: 'master.tarif_shift',
        path: `${APP_PREFIX_PATH}/master/tarif_shift`,
        component: React.lazy(() => import('views/app-views/tarif_shift/Index')),
    },{
        key: 'master.pegawai',
        path: `${APP_PREFIX_PATH}/master/pegawai`,
        component: React.lazy(() => import('views/app-views/pegawai/Index')),
    },{
        key: 'master.tali_asih',
        path: `${APP_PREFIX_PATH}/master/tali_asih`,
        component: React.lazy(() => import('views/app-views/tali_asih/Index')),
    },{
        key: 'master.tunjangan',
        path: `${APP_PREFIX_PATH}/master/tunjangan`,
        component: React.lazy(() => import('views/app-views/tunjangan/Index')),
    },{
        key: 'master.potongan',
        path: `${APP_PREFIX_PATH}/master/potongan`,
        component: React.lazy(() => import('views/app-views/potongan/Index')),
    },{
        key: 'master.persentase_biaya',
        path: `${APP_PREFIX_PATH}/persentase_biaya/data`,
        component: React.lazy(() => import('views/app-views/persentase_biaya/Index')),
    },{
        key: 'master.exit_clearence',
        path: `${APP_PREFIX_PATH}/master/exit_clearence`,
        component: React.lazy(() => import('views/app-views/exit_clearence/Index')),
    },{
        key: 'project.data',
        path: `${APP_PREFIX_PATH}/project/data`,
        component: React.lazy(() => import('views/app-views/project/Index')),
    },{
        key: 'penggajian.proses',
        path: `${APP_PREFIX_PATH}/penggajian/proses`,
        component: React.lazy(() => import('views/app-views/pengajuan_gaji/Index')),
    },{
        key: 'penggajian.proses.form',
        path: `${APP_PREFIX_PATH}/penggajian/proses/form`,
        component: React.lazy(() => import('views/app-views/pengajuan_gaji/Form')),
    },{
        key: 'lembur.data',
        path: `${APP_PREFIX_PATH}/lembur/data`,
        component: React.lazy(() => import('views/app-views/lembur/Index')),
    },{
        key: 'pengajuan.pembayaran',
        path: `${APP_PREFIX_PATH}/pengajuan/pembayaran`,
        component: React.lazy(() => import('views/app-views/pengajuan_pembayaran/Index')),
    },{
        key: 'presensi.persetujuan',
        path: `${APP_PREFIX_PATH}/presensi/persetujuan`,
        component: React.lazy(() => import('views/app-views/persetujuan_presensi/Index')),
    },{
        key: 'presensi.daftar',
        path: `${APP_PREFIX_PATH}/presensi/daftar`,
        component: React.lazy(() => import('views/app-views/presensi/Daftar')),
    },{
        key: 'pengajuan.pembayaran.review',
        path: `${APP_PREFIX_PATH}/pengajuan/pembayaran/review`,
        component: React.lazy(() => import('views/app-views/pengajuan_pembayaran/ReviewData')),
    },{
        key: 'sppd.data',
        path: `${APP_PREFIX_PATH}/sppd/data`,
        component: React.lazy(() => import('views/app-views/sppd_proyek/Index')),
    },{
        key: 'verifikasi.data',
        path: `${APP_PREFIX_PATH}/verifikasi/persetujuan`,
        component: React.lazy(() => import('views/app-views/verifikasi/ApprovalData')),
    },{
        key: 'verifikasi.data.operasional',
        path: `${APP_PREFIX_PATH}/verifikasi/persetujuan_operasional`,
        component: React.lazy(() => import('views/app-views/verifikasi_operasional/ApprovalData')),
    },{
        key: 'tagihan.data',
        path: `${APP_PREFIX_PATH}/tagihan/persetujuan`,
        component: React.lazy(() => import('views/app-views/tagihan/ApprovalData')),
    },{
        key: 'pengajuan.tagihan',
        path: `${APP_PREFIX_PATH}/pengajuan/tagihan`,
        component: React.lazy(() => import('views/app-views/pengajuan_tagihan/Index')),
    },{
        key: 'pengajuan.tagihan.form',
        path: `${APP_PREFIX_PATH}/pengajuan/tagihan/form`,
        component: React.lazy(() => import('views/app-views/pengajuan_tagihan/Form')),
    },{
        key: 'pengaturan.pengawas',
        path: `${APP_PREFIX_PATH}/pengaturan/pengawas`,
        component: React.lazy(() => import('views/app-views/pengawas/Index')),
    },{
        key: 'pengaturan.pengguna',
        path: `${APP_PREFIX_PATH}/pengaturan/pengguna`,
        component: React.lazy(() => import('views/app-views/pengaturan/pengguna/Index')),
    },{
        key: 'pengaturan.pengguna.change_password',
        path: `${APP_PREFIX_PATH}/pengaturan/pengguna/change_password`,
        component: React.lazy(() => import('views/app-views/pengaturan/pengguna/FormGantiPassword')),
    },{
        key: 'pengaturan.potongan_keterlambatan_proyek',
        path: `${APP_PREFIX_PATH}/pengaturan/potongan_keterlambatan`,
        component: React.lazy(() => import('views/app-views/potongan_keterlambatan_proyek/Index')),
    },{
        key: 'report.lembur',
        path: `${APP_PREFIX_PATH}/laporan/lembur`,
        component: React.lazy(() => import('views/app-views/report/lembur/Index')),
    },{
        key: 'shift.data',
        path: `${APP_PREFIX_PATH}/shift/data`,
        component: React.lazy(() => import('views/app-views/shift/Index')),
    },{
        key: 'shift.pegawai',
        path: `${APP_PREFIX_PATH}/shift/pegawai`,
        component: React.lazy(() => import('views/app-views/pegawai_shift/Index')),
    },{
        key: 'shift.jadwal_shift',
        path: `${APP_PREFIX_PATH}/shift/jadwal_shift`,
        component: React.lazy(() => import('views/app-views/jadwal_shift/Index')),
    },{
        key: 'master.pegawai.subkon',
        path: `${APP_PREFIX_PATH}/master/pegawai_subkon`,
        component: React.lazy(() => import('views/app-views/pegawai_subkon/Index')),
    },{
        key: 'pengajuan.pembayaran.subkon',
        path: `${APP_PREFIX_PATH}/pengajuan/pembayaran_subkon`,
        component: React.lazy(() => import('views/app-views/pengajuan_pembayaran_subkon/Index')),
    },{
        key: 'pengajuan.pembayaran.subkon.review',
        path: `${APP_PREFIX_PATH}/pengajuan/pembayaran_subkon/review`,
        component: React.lazy(() => import('views/app-views/pengajuan_pembayaran_subkon/ReviewData')),
    }


]
